import React from 'react';
import { HeroVariant23 } from '../components/HeroVariant23';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage23() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1537">
      <Navigation data-id="element-1538" />
      <main data-id="element-1539">
        <HeroVariant23 data-id="element-1540" />
        <WhyUs data-id="element-1541" />
        <Services data-id="element-1542" />
        <FAQ data-id="element-1543" />
        <Testimonials data-id="element-1544" />
        <Consultation data-id="element-1545" />
      </main>
      <Footer data-id="element-1546" />
      <CookieBanner data-id="element-1547" />
      <FloatingContact data-id="element-1548" />
    </div>;
}